<template>
  <div class="default-component-loader">
    <OwnProgressSpinner size="20" />
    <OwnType
      v-if="message"
      :text="message"
      variant="paragraph-regular"
      color="tertiary"
    />
  </div>
</template>

<script lang="ts" setup>
import { OwnProgressSpinner } from '@/ui/OwnProgressSpinner'
import { OwnType } from '@/ui/OwnType'

defineProps<{
  message: string
}>()
</script>

<style lang="scss" scoped>
.default-component-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 40px 24px;
}
</style>
